/** React bindings for the transport-activity store and the log buffer. */
import { useEffect, useSyncExternalStore } from 'react';
import { activity, type ActivitySnapshot } from './activity';
import { logStore, type LogEntry } from './logger';

/**
 * Subscribes to connection/in-flight state and keeps it in step with the
 * browser's own online/offline events.
 */
export function useActivity(): ActivitySnapshot {
  const snapshot = useSyncExternalStore(activity.subscribe, activity.snapshot, activity.snapshot);

  useEffect(() => {
    const on = () => activity.setBrowserOnline(true);
    const off = () => activity.setBrowserOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  return snapshot;
}

/** The client log ring buffer, live. */
export function useLogs(): readonly LogEntry[] {
  return useSyncExternalStore(logStore.subscribe, logStore.snapshot, logStore.snapshot);
}
